/*
 * Bouton « Passer en abonnement » du panier (voir snippets/line-item.liquid) :
 * transforme un article acheté en achat unique (ex : l'Offre découverte) en
 * abonnement, en changeant le plan d'achat du même article via l'API panier
 * Shopify, sans changer sa quantité.
 *
 * Suit le même schéma que la mise à jour de quantité du thème (assets/theme.js,
 * classe LineItemQuantity) : on annonce les sections à re-rendre via
 * "cart:prepare-bundled-sections", puis on notifie le reste du thème via
 * "cart:change" pour que le panier tiroir se re-rende avec le contenu à jour.
 */
(function () {
  function definirEtatChargement(bouton, enCours) {
    bouton.disabled = enCours;
    bouton.classList.toggle('is-loading', enCours);
  }

  function transformerEnAbonnement(bouton) {
    var lineKey = bouton.getAttribute('data-line-key');
    var sellingPlanId = bouton.getAttribute('data-selling-plan-id');
    var quantity = parseInt(bouton.getAttribute('data-quantity'), 10) || 1;

    if (!lineKey || !sellingPlanId) return;

    definirEtatChargement(bouton, true);
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

    var sectionsABundler = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sectionsABundler } })
    );

    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: lineKey,
        quantity: quantity,
        selling_plan: sellingPlanId,
        sections: sectionsABundler.join(',')
      })
    })
      .then(function (response) { return response.json(); })
      .then(function (cartContent) {
        if (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.pageType === 'cart') {
          window.location.reload();
          return;
        }

        document.documentElement.dispatchEvent(
          new CustomEvent('cart:change', {
            bubbles: true,
            detail: { baseEvent: 'line-item:change', cart: cartContent }
          })
        );
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(function () {})
      .finally(function () {
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
        definirEtatChargement(bouton, false);
      });
  }

  document.addEventListener('click', function (event) {
    var bouton = event.target.closest('[data-line-item-subscribe]');
    if (!bouton) return;
    event.preventDefault();
    transformerEnAbonnement(bouton);
  });
})();
